// Configuration constants (immutable)
const OneSignalAppId = 'efae2c57-b749-45b7-9368-17a4209076f8';
const WelcomeNotificationString = 'https://www.mayesh.com?utm_campaign=Web%20App&utm_source=APP&utm_content=welcome';

/**
 * Composable for accessing application configuration variables
 * Note: These are constant values, not reactive
 * @returns {Object} Configuration values
 */
export function useConfigVars() {
  return {
    OneSignalAppId,
    WelcomeNotificationString
  };
}

// Named exports for direct access
export { OneSignalAppId, WelcomeNotificationString };

// Default export for convenience
export default { 
  OneSignalAppId, 
  WelcomeNotificationString 
};

